import { gql } from "@apollo/client";

export const GET_ALL_PROJECT_DIMENSIONS = gql`
	query ($model: GetProjectDimensionsRequestInput!) {
		GetAllProjectDimensions(model: $model) {
			projectDimension1
			projectDimension2
			errorCode
			errorMessage
			errorVariables
		}
	}
`;
export const GET_CUSTOMER_BY_ID = gql`
	query ($customerID: UUID!) {
		GetCustomer(id: $customerID) {
			customer {
				name
				code
				customerGuid
				creationDate
				modificationDate
				company {
					companyGuid
					name
				}
			}
			errorCode
			errorMessage
			errorVariables
		}
	}
`;

export const DELETE_CUSTOMER_LIST = gql`
	mutation ($model: DeleteCustomerListRequestInput!) {
		DeleteCustomersList(model: $model) {
			crudCustomer
			errorCode
			errorMessage
			errorVariables
		}
	}
`;

export const GET_ALL_CUSTOMERS = gql`
	query ($model: CustomerRequestInput!) {
		GetAllCustomers(model: $model) {
			customers {
				name
				code
				customerGuid
				createdBy
				creationDate
				modificationDate
				company {
					companyGuid
					name
				}
			}
			totalNumberOfRecords
			errorCode
			errorMessage
			errorVariables
		}
	}
`;
export const GET_ALL_CUSTOMERS_DROPDOWN = gql`
	query ($model: CustomerRequestInput!) {
		GetAllCustomers(model: $model) {
			customers {
				name
				customerGuid
			}
			errorCode
			errorMessage
			errorVariables
		}
	}
`;
export const UPDATE_CUSTOMER = gql`
	mutation ($model: EditCustomerRequestInput!) {
		EditCustomer(model: $model) {
			crudCustomer
			errorCode
			errorMessage
			errorVariables
		}
	}
`;

export const CREATE_CUSTOMER = gql`
	mutation ($model: CreateCustomerRequestInput!) {
		CreateCustomer(model: $model) {
			crudCustomer
			errorCode
			errorMessage
			errorVariables
		}
	}
`;

export const DELETE_CUSTOMER = gql`
	mutation ($model: DeleteCustomerRequestInput!) {
		DeleteCustomer(model: $model) {
			crudCustomer
			errorCode
			errorMessage
			errorVariables
		}
	}
`;
